import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} CarrierService
 * @property {string|number} id
 * @property {string} name
 * @property {string} service_name
 * @property {string} service_code
 * @property {string} carrier_name
 * @property {string} carrier
 * @property {string|number} carrier_id
 * @property {string|number} carrier_integration_id
 * @property {boolean} is_international
 */

/**
 * @typedef {Object} CarrierServicesSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {CarrierService[]} data
 */

export const CARRIER_SERVICES_ACTIONS = {
  SET_CARRIER_SERVICES: 'SET_CARRIER_SERVICES',
  SET_CARRIER_SERVICE: 'SET_CARRIER_SERVICE',
  SET_STATUS: 'SET_CARRIER_SERVICES_STATUS',
  SET_ERRORS: 'SET_CARRIER_SERVICES_ERRORS',
  CLEAR_ERRORS: 'CLEAR_CARRIER_SERVICES_ERRORS',
  CLEAR_CARRIER_SERVICES: 'CLEAR_CARRIER_SERVICES'
}

export const initialCarrierServicesState = {
  status: 'idle',
  errors: [],
  data: []
}

export const carrierServicesPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      service_name: PropTypes.string,
      service_code: PropTypes.string,
      carrier_name: PropTypes.string,
      carrier: PropTypes.string,
      carrier_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      carrier_integration_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      is_international: PropTypes.bool
    })
  )
}
